import React from 'react';

import LeftToolbar from './LeftToolbar/LeftToolbar';
import RightToolbar from './RightToolbar/RightToolbar';
import EboardLogo from '../../../Logo/STL/EboardLogo';

const toolbar = () => (
    <div className="collapse navbar-collapse navbar-collapse-toolbar" id="site-navbar-collapse">
        <LeftToolbar />
        <EboardLogo />
        <RightToolbar />
    </div>
);

export default toolbar;